import React, { PureComponent } from "react";

import "./Button.css";

class Button extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            active: false,
        }
    }

    render() {

        let borderColor = this.props.borderColor;
        if (typeof this.props.activeBorderColor !== 'undefined' && this.state.hovered)
            borderColor = this.props.activeBorderColor;

        return (
            <button
                className="Button"
                style={{
                    backgroundColor: (this.state.hovered ? this.props.activeColor : this.props.inactiveColor),
                    border: '1px solid ' + borderColor,
                    color: (this.state.hovered ? this.props.inactiveColor : this.props.activeColor),
                    transition: 'transform 80ms, background-color 80ms, color 80ms, border 80ms',
                    transform: 'scale(' + (this.state.active ? '0.85' : '1.0') + ')',
                }}
                onMouseEnter={() => {
                    this.setState({hovered: true});
                }}
                onMouseLeave={() => {
                    this.setState({hovered: false, active: false});
                }}
                onMouseDown={() => {
                    this.setState({active: true});
                }}
                onMouseUp={() => {
                    this.setState({active: false});
                }}
                onTouchStart={() => {
                    this.setState({active: true, hovered: true});
                }}
                onTouchEnd={() => {
                    this.setState({active: false, hovered: false});
                }}
                onClick={() => {

                    this.setState({active: false, hovered: false});

                    if (window.TapticEngine) window.TapticEngine.impact({ style: "medium" });

                    if (typeof this.props.onClick === 'function')
                        this.props.onClick();
                }}
            >
                {this.props.children}
            </button>
        );
    }
}

export default Button;
